import { ImmigrationStatus } from '../types';
import styles from '../form-submissions.module.css';
import { Globe, Calendar, User, FileCheck } from 'lucide-react';

interface ImmigrationStatusCardProps {
  immigration: ImmigrationStatus;
}

export function ImmigrationStatusCard({ immigration }: ImmigrationStatusCardProps) {
  const formatDate = (dateString: string) => {
    if (!dateString) return '—';
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  const getWhoIsThisForLabel = (value: string) => {
    switch (value) {
      case 'self':
        return 'Myself';
      case 'other':
        return 'Someone else';
      default:
        return '—';
    }
  };

  return (
    <div className={styles.sectionCard}>
      <div className={styles.sectionHeader}>
        <div className={styles.sectionIcon}>
          <Globe size={18} />
        </div>
        <h3 className={styles.sectionTitle}>Immigration Status</h3>
      </div>

      <div className={styles.sectionContent}>
        <div className={styles.dataRow}>
          <span className={styles.dataLabel}>Current Visa</span>
          <span className={styles.dataValue}>
            <span className={`${styles.badge} ${styles.badgeVisa}`}>
              {immigration.currentVisaStatus || '—'}
            </span>
          </span>
        </div>

        <div className={styles.dataRow}>
          <span className={styles.dataLabel}>
            <Calendar size={13} />
            Visa Expiry
          </span>
          <span className={styles.dataValue}>{formatDate(immigration.visaExpiryDate)}</span>
        </div>

        <div className={styles.dataRow}>
          <span className={styles.dataLabel}>
            <User size={13} />
            Application For
          </span>
          <span className={styles.dataValue}>{getWhoIsThisForLabel(immigration.whoIsThisFor)}</span>
        </div>

        <div className={styles.dataRow}>
          <span className={styles.dataLabel}>
            <FileCheck size={13} />
            Green Card Started
          </span>
          <span className={styles.dataValue}>
            {immigration.greenCardCaseStarted === 'yes' ? (
              <span className={styles.textGreen}>Yes</span>
            ) : immigration.greenCardCaseStarted === 'no' ? (
              <span className={styles.textRed}>No</span>
            ) : (
              '—'
            )}
          </span>
        </div>

        {immigration.priorityDate && (
          <div className={styles.dataRow}>
            <span className={styles.dataLabel}>Priority Date</span>
            <span className={styles.dataValue}>{formatDate(immigration.priorityDate)}</span>
          </div>
        )}
      </div>
    </div>
  );
}
